import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { checkNull } from "../../../helpers";
import { userLogout } from "../../../Redux/actions";


const NavbarNew = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user_details } = useSelector((state) => state.authReducer);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [activeBar, setActiveBar] = useState(false);
  const [subMenuArr, setSubMenuArr] = useState([]);

  const tabClickHandler = useCallback(
    (val, openSub = true) => {
      if (openSub) {
        if (openSubMenu && selectedMenu !== val) {
          setOpenSubMenu(false);
          setTimeout(() => {
            setOpenSubMenu(true);
          }, 200);
        } else {
          setOpenSubMenu(true);
        }
      } else {
        setOpenSubMenu(false);
      }
      setSelectedMenu(val);
    },
    [openSubMenu, selectedMenu]
  );

  useEffect(() => {
    const getPaths = location.pathname.split("/");
    const getFirstPath = getPaths?.[1] ?? "";
    const getSecondPath = getPaths?.[2] ?? "";
    if (getFirstPath !== "") {
      setActiveMenu(getFirstPath);
    }
    if (getSecondPath !== "") {
      setActiveSubMenu(getSecondPath);
    }
    setOpenSubMenu(false);
  }, []);

  useEffect(() => {
    let newSubItems = [];
    switch (selectedMenu) {
      case "dashboard":
        newSubItems = [
          {
            name: "home",
            class: "pro-menu-item menu-title",
            title: "Dashboard",
            icon: "dashboard-small",
          },
          {
            name: "dashboard",
            class: "pro-menu-item active",
            title: "Dashboard",
            path: "/dashboard",
          },
        ];
        break;
      case "finance":
        newSubItems = [
          {
            name: "menu_engineer",
            class: "pro-menu-item menu-title",
            title: "Finance",
            icon: "finance-small",
          },
          {
            name: "sales",
            class: "pro-menu-item",
            title: "Sales",
            path: "/finance/sales",
          },
          {
            name: "expense",
            class: "pro-menu-item",
            title: "Expense",
            path: "/finance/expenses",
          },
          {
            name: "payments",
            class: "pro-menu-item",
            title: "Payments",
            path: "/finance/payments",
          },
          {
            name: "payables",
            class: "pro-menu-item",
            title: "Payables",
            path: "/finance/payables",
          },
          {
            name: "receivables",
            class: "pro-menu-item",
            title: "Receivables",
            path: "/finance/receivables",
          },
          {
            name: "assets",
            class: "pro-menu-item",
            title: "Assets",
            path: "/finance/assets",
          },
          {
            name: "general-ledger",
            class: "pro-menu-item",
            title: "General Ledger",
            path: "/finance/general-ledger",
          },
          {
            name: "vouchers",
            class: "pro-menu-item",
            title: "Vouchers",
            path: "/finance/vouchers",
          },
          {
            name: "reconciliation",
            class: "pro-menu-item",
            title: "reconciliation",
            path: "/finance/reconciliation",
          },
        ];
        break;
      case "order":
        newSubItems = [
          {
            name: "orders_invoices",
            class: "pro-menu-item menu-title",
            title: "Orders & Invoices",
            icon: "orderInvoice-small",
          },
          {
            name: "trade",
            class: "pro-menu-item",
            title: "Trade Orders",
            path: "/order/trade",
          },
          {
            name: "non-trade",
            class: "pro-menu-item",
            title: "Non-Trade Orders",
            path: "/order/non-trade",
          },
          {
            name: "ap-invoices",
            class: "pro-menu-item",
            title: "AP Invoices",
            path: "/order/ap-invoices",
          },
          {
            name: "ar-invoices",
            class: "pro-menu-item",
            title: "AR Invoices",
            path: "/order/ar-invoices",
          },
          {
            name: "payees",
            class: "pro-menu-item",
            title: "Payees",
            path: "/order/payees",
          },
          {
            name: "customers",
            class: "pro-menu-item",
            title: "Customers",
            path: "/order/customers",
          },
        ];
        break;
      case "labor":
        newSubItems = [
          {
            name: "labor",
            class: "pro-menu-item menu-title",
            title: "Labor",
            icon: "labor-small",
          },
          {
            name: "shift",
            class: "pro-menu-item",
            title: "Shift",
            path: "/labor/shift",
          },
          {
            name: "scheduler",
            class: "pro-menu-item",
            title: "Scheduler",
            path: "/labor/scheduler",
          },
          {
            name: "payroll",
            class: "pro-menu-item",
            title: "Payroll",
            path: "/labor/payroll",
          },
          {
            name: "salary-slips",
            class: "pro-menu-item",
            title: "Salary Slips",
            path: "/labor/salary-slips",
          },
          {
            name: "leave-and-claims",
            class: "pro-menu-item",
            title: "Leave & Claims",
            path: "/labor/leave-and-claims",
          },
        ];
        break;
      case "menu":
        newSubItems = [
          {
            name: "menu_engineer",
            class: "pro-menu-item menu-title",
            title: "Menu Engineer",
            icon: "menuEngineer-small",
          },
          {
            name: "items",
            class: "pro-menu-item",
            title: "Menu Items",
            path: "/menu/items",
          },
          {
            name: "recipes",
            class: "pro-menu-item",
            title: "Recipes",
            path: "/menu/recipes",
          },
          {
            name: "ingredients",
            class: "pro-menu-item",
            title: "Ingredients",
            path: "/menu/ingredients",
          },
          {
            name: "pricing",
            class: "pro-menu-item",
            title: "Menu Pricing",
            path: "/menu/pricing",
          },
          {
            name: "promotions",
            class: "pro-menu-item",
            title: "Promotions",
            path: "/menu/promotions",
          },
        ];
        break;
      case "inventory":
        newSubItems = [
          {
            name: "inventory",
            class: "pro-menu-item menu-title",
            title: "Inventory",
            icon: "inventory-small",
          },
          {
            name: "inventories",
            class: "pro-menu-item",
            title: "Inventory",
            path: "/inventory/inventories",
          },
          {
            name: "productions",
            class: "pro-menu-item",
            title: "Production",
            path: "/inventory/productions",
          },
          {
            name: "counts",
            class: "pro-menu-item",
            title: "Counts",
            path: "/inventory/counts",
          },
          {
            name: "wastes",
            class: "pro-menu-item",
            title: "Wastes",
            path: "/inventory/wastes",
          },
        ];
        break;
      case "reporting":
        newSubItems = [
          {
            name: "reporting",
            class: "pro-menu-item menu-title",
            title: "Analytics & Reporting",
            icon: "reporting-small",
          },
          {
            name: "general-finance-summary",
            class: "pro-menu-item",
            title: "Financial",
            path: "/reporting/finance-summary",
          },
          {
            name: "labor-summary",
            class: "pro-menu-item",
            title: "Labor",
            path: "/reporting/labor-summary",
          },
          {
            name: "inventory-summary",
            class: "pro-menu-item",
            title: "Inventory",
            path: "/reporting/inventory-summary",
          },
          {
            name: "reports",
            class: "pro-menu-item",
            title: "Reporting",
            path: "/reporting/reports",
          },
        ];
        break;
      case "settings":
        newSubItems = [
          {
            name: "settings",
            class: "pro-menu-item menu-title",
            title: "Settings",
            icon: "settings-small",
          },
          {
            name: "finance",
            class: "pro-menu-item",
            title: "Finance",
            path: "/settings/finance",
            icon: "finance-smaller va",
          },
          {
            name: "order",
            class: "pro-menu-item",
            title: "Orders & Invoices",
            path: "/settings/order",
            icon: "orderInvoice-small",
          },
          {
            name: "labor",
            class: "pro-menu-item",
            title: "Labor",
            path: "/settings/labor",
            icon: "labor-smaller va",
          },
          {
            name: "inventory",
            class: "pro-menu-item",
            title: "Inventory",
            path: "/settings/inventory",
            icon: "inventory-smaller va",
          },
          {
            name: "onlife-sites-setup",
            class: "pro-menu-item",
            title: "Onlife",
            path: "/settings/onlife-sites-setup",
            icon: "onlife-small va",
          },
          {
            name: "clipboard",
            class: "pro-menu-item",
            title: "Clipboard",
            path: "/settings/clipboard",
            icon: "clipboard-small va",
          },
          {
            name: "pos",
            class: "pro-menu-item",
            title: "POS Master",
            path: "/settings/pos",
            icon: "pos_icon2",
          },
          {
            name: "integrations",
            class: "pro-menu-item",
            title: "Integration",
            path: "/settings/integrations",
            icon: "integration",
          },
          {
            name: "profile",
            class: "pro-menu-item",
            title: `${user_details?.user?.first_name} ${user_details?.user?.last_name}`,
            path: "/settings/profile",
          },
          {
            name: "user-management",
            class: "pro-menu-item",
            title: "Users",
            path: "/settings/user-management",
          },
          {
            name: "account-settings",
            class: "pro-menu-item",
            title: "Account",
            path: "/settings/account-settings",
          },
          {
            name: "support-settings",
            class: "pro-menu-item",
            title: "Support",
          },
          {
            name: "logout",
            class: "pro-menu-item",
            title: "Sign Out",
            path: "/logout",
            icon: "signout-small va",
          },
        ];
        break;
      default:
        break;
    }
    setSubMenuArr(newSubItems);
  }, [selectedMenu]);

  const getSubMenuItems = () => {
    let res = (
      <ul>
        {subMenuArr &&
          subMenuArr.length > 0 &&
          subMenuArr.map((item, idx) => {
            return (
              <li
                className={`${item.class}${
                  checkNull(item?.name, false) && item?.name == activeSubMenu
                    ? " active"
                    : ""
                }`}
                onClick={() => history.push(item?.path)}
              >
                <div className="pro-inner-item" tabIndex="0" role="button">
                  {item?.icon && idx == 0 && (
                    <span className="pro-icon-wrapper">
                      <span className="pro-icon">
                        <i className={`${item?.icon}`}></i>
                      </span>
                    </span>
                  )}
                  {item?.icon && idx != 0 && (
                    <i className={`${item?.icon}`}></i>
                  )}
                  <span className="pro-item-content">{`${item.title}`}</span>
                </div>
              </li>
            );
          })}
      </ul>
    );
    if (selectedMenu == "settings") {
      res = (
        <>
          <ul className="first">
            {subMenuArr &&
              subMenuArr.length > 0 &&
              subMenuArr.slice(0, 9).map((item, idx) => {
                return (
                  <li
                    className={`${item.class}${
                      checkNull(item?.name, false) &&
                      item?.name == activeSubMenu
                        ? " active"
                        : ""
                    }`}
                    onClick={() => {
                      if (item?.name == "logout") {
                        dispatch(userLogout());
                      } else if (item?.path) {
                        history.push(item?.path);
                      }
                    }}
                  >
                    <div className="pro-inner-item" tabIndex="0" role="button">
                      {item?.icon && idx == 0 && (
                        <span className="pro-icon-wrapper">
                          <span className="pro-icon">
                            <i className={`${item?.icon}`}></i>
                          </span>
                        </span>
                      )}
                      {item?.icon && idx != 0 && (
                        <i className={`${item?.icon}`}></i>
                      )}
                      <span className="pro-item-content">{`${item.title}`}</span>
                    </div>
                  </li>
                );
              })}
          </ul>
          <ul className="second">
            {subMenuArr &&
              subMenuArr.length > 0 &&
              subMenuArr.slice(9, subMenuArr.length).map((item, idx) => {
                return (
                  <li
                    className={`${item.class}${
                      checkNull(item?.name, false) &&
                      item?.name == activeSubMenu
                        ? " active"
                        : ""
                    }`}
                    onClick={() => {
                      if (item?.name == "logout") {
                        dispatch(userLogout());
                      } else if (item?.path) {
                        history.push(item?.path);
                      }
                    }}
                  >
                    <div className="pro-inner-item" tabIndex="0" role="button">
                      {item?.icon && idx == 0 && (
                        <span className="pro-icon-wrapper">
                          <span className="pro-icon">
                            <i className={`${item?.icon}`}></i>
                          </span>
                        </span>
                      )}
                      {item?.icon && idx != 0 && (
                        <i className={`${item?.icon}`}></i>
                      )}
                      <span className="pro-item-content">{`${item.title}`}</span>
                    </div>
                  </li>
                );
              })}
          </ul>
        </>
      );
    }
    return res;
  };

  return (
    <Fragment>
      <nav className="pro-sidebar-layout">
        <div className="pro-sidebar-header">
          <a href="#_" className="logo_image" title="GoGMGo"></a>
          <ul class="header_actions mb-0 mx-2 d-block d-md-none">
            <li class="responsive_menu" onClick={()=>setActiveBar(!activeBar)}>
              <FontAwesomeIcon icon="bars" />
            </li>
          </ul>
        </div>
        <div className={`navbar-menu ${activeBar?"show":""}`}>
          <ul className="middleMenu">
            <li
              className={`dashboard${
                activeMenu == "dashboard" ? " active" : ""
              }`}
              onClick={() =>
                tabClickHandler(
                  "dashboard",
                  selectedMenu == "dashboard" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_dashboard"></i>
              </a>
            </li>
            <li
              className={`finance${activeMenu == "finance" ? " active" : ""}`}
              onClick={() =>
                tabClickHandler(
                  "finance",
                  selectedMenu == "finance" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_finance"></i>
              </a>
            </li>
            <li
              className={`orderInvoice${
                activeMenu == "order" ? " active" : ""
              }`}
              onClick={() =>
                tabClickHandler(
                  "order",
                  selectedMenu == "order" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_orderInvoice"></i>
              </a>
            </li>
            <li
              className={`labor${activeMenu == "labor" ? " active" : ""}`}
              onClick={() =>
                tabClickHandler(
                  "labor",
                  selectedMenu == "labor" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_labor"></i>
              </a>
            </li>
            <li
              className={`menuEngineer${activeMenu == "menu" ? " active" : ""}`}
              onClick={() =>
                tabClickHandler(
                  "menu",
                  selectedMenu == "menu" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_menuEngineer"></i>
              </a>
            </li>
            <li
              className={`inventory${
                activeMenu == "inventory" ? " active" : ""
              }`}
              onClick={() =>
                tabClickHandler(
                  "inventory",
                  selectedMenu == "inventory" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_inventory"></i>
              </a>
            </li>
            <li
              className={`onlife${activeMenu == "onlife" ? " active" : ""}`}
              onClick={() => history.push("/onlife")}
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_onlife"></i>
              </a>
            </li>
            <li
              className={`analysticReporting${
                activeMenu == "reporting" ? " active" : ""
              }`}
              onClick={() =>
                tabClickHandler(
                  "reporting",
                  selectedMenu == "reporting" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_reporting"></i>
              </a>
            </li>
          </ul>

          <ul className="lowerMenu">
            <li
              className={`clipboard${
                activeMenu == "clipboard" ? " active" : ""
              }`}
              onClick={() => history.push("/clipboard")}
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_manager_log"></i>
              </a>
            </li>
            <li
              className={`setting${activeMenu == "settings" ? " active" : ""}`}
              onClick={() =>
                tabClickHandler(
                  "settings",
                  selectedMenu == "settings" ? !openSubMenu : true
                )
              }
            >
              <a role={"button"}>
                <i className="icon-sprite img_icon_setting"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <div className={`subMenus`}>
        <div
          className={`innerMenus${openSubMenu ? " active" : ""}`}
          id="settingsMenu"
        >
          {getSubMenuItems()}
        </div>
      </div>
    </Fragment>
  );
};
export default NavbarNew;
